<template>
    <sys-register-base
        :loading="loading"
        @onSave="save"
        :model.sync="model"
        :title="title"
        icon="mdi-city"
        v-bind:show.sync="dialog"
        maxWidth="50%"
    >
        <template v-slot:form>
            <v-container>
                <v-row>
                    <v-col cols="12" sm="12">
                        <sys-select-institution-type
                            :model.sync="model.institution_type_id"
                            :error="!!errors.institution_type_id"
                            :errors="errors.institution_type_id"
                            label="Tipo de Instituição*"
                            dense
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            type="number"
                            step="0.01"
                            suffix="%"
                            clearable
                            :error="!!errors.min_master_doctors"
                            :error-messages="errors.min_master_doctors"
                            v-model="model.min_master_doctors"
                            label="% Mínimo Mestres/Doutores"
                            hint="Deixe em branco quando não houver piso legal fixo"
                            persistent-hint
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            type="number"
                            step="0.01"
                            suffix="%"
                            clearable
                            :error="!!errors.min_fulltime"
                            :error-messages="errors.min_fulltime"
                            v-model="model.min_fulltime"
                            label="% Mínimo Tempo Integral"
                            hint="Deixe em branco quando não houver piso legal fixo"
                            persistent-hint
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12">
                        <v-textarea
                            :error="!!errors.description"
                            :error-messages="errors.description"
                            v-model="model.description"
                            label="Base Legal / Observação"
                            rows="3"
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-container>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: "SysRegisterInstitutionTypeRule",
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        loading: false,
    }),

    watch: {

        dialog(dialog_new, dialog_old) {
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }
        },

        show(show_new, show_old) {
            this.dialog = show_new;

            if(show_new){
                this.error = false;
                this.errors = {};
            }
        },

    },
    props: {
        model: {
            default: null
        },
        title: {
            type: String,
            default: "Regra por Tipo de Instituição"
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('institutionTypeRule', ['ActionUpdateInstitutionTypeRule', 'ActionCreateInstitutionTypeRule']),

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;

            if(edit) {
                this.ActionUpdateInstitutionTypeRule(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                     this.loading = false;
                })
            } else {
                this.ActionCreateInstitutionTypeRule(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                   this.loading = false;
                })

            }
        },

    }
}
</script>
